/* eslint-disable class-methods-use-this */
/* eslint-disable prefer-rest-params */
/* eslint-disable max-len */
import {LIVE_BASE_URL, ENV_NAME} from '../requestUrl/live'
import http from './http'

/**
 * 直播间内业务请求封装
 */
class PlayerHttp {
  constructor() {
    this.requestList = [] // 缓存请求接口
    this.isStoreLoggingIn = false // 正在店铺登录
    this.requestLimit = 0 // 请求次数限制
  }

  get(url, params, isNeedBiz = true, config = {}, host) {
    return this.request('get', url, params, isNeedBiz, config, host)
  }

  post(url, params, isNeedBiz = true, config = {}, host) {
    return this.request('post', url, params, isNeedBiz, config, host)
  }

  /**
   * @description 网络请求发送
   * @param {String} method 网络请求类型 get/post
   * @param {String} url 网络请求地址
   * @param {Object} params 请求传参
   * @param {Boolean} [isNeedBiz=true] 是否套层 bizData
   * @param {Object} [config={}] 网络请求 header 扩展
   * @param {host} [host=''] host 自定义扩展
   */
  request(method, url, params, isNeedBiz = true, config, host = '') {
    const _params = arguments
    const that = this
    const appId = wx.getStorageSync('storeId') || '' // 店铺id
    const koToken = wx.getStorageSync('koToken') || ''
    if (method === 'get') {
      isNeedBiz = false
    }
    const theParams = isNeedBiz ? {bizData: params} : params
    let {header} = config
    header = header || {}
    header.app_id = appId
    header.Cookie = `ko_token=${koToken}`

    // 判断是否自定义域名
    const BASE_URL = host ? this.getCustomBaseUrl(host) : LIVE_BASE_URL

    // 非自定义域名都需加_alive
    if (host === '') {
      url = url.includes('_alive') || url === 'information_form/save_informationv3' ? url : '_alive/' + url
    }

    /**
     * 配置条件: _alive/xxx || information_form/save_informationv3
     * 无需配置: _alive/open/xxx || _alive/elive/xxx
     */
    if (/_alive\/(?!(open|elive))/.test(url) || url === 'information_form/save_informationv3') {
      header.kpi_client = 9
      header.AppId = appId
    }

    return new Promise(function (resolve, reject) {
      wx.request({
        url: BASE_URL + url,
        method,
        data: theParams,
        header,
        success(res) {
          if (res.statusCode === 200) {
            switch (res.data.code) {
              case 0: // 0 请求数据成功
                resolve(res)
                break
              case 200:
                resolve(res)
                break
              case 11302:
              case 10500: // token 失效
                that.requestList.push(() => resolve(that.request(..._params)))
                if (!that.isStoreLoggingIn && that.requestLimit < 5) {
                  wx.showLoading({
                    title: '正在登录',
                  })
                  that.isStoreLoggingIn = true
                  setTimeout(() => {
                    that.wxLogin()
                    that.requestLimit++
                  }, 2000)
                }
                break
              default: // 其他错误
                resolve(res)
                break
            }
          } else {
            // 请求接口失败
            reject(res)
          }
        },
        fail(err) {
          reject(err)
        }
      })
    })
  }

  /**
   * 直播间获取 ko_token
   */
  getKotoken() {
    const appId = wx.getStorageSync('storeId') || '' // 店铺id
    const unionId = wx.getStorageSync('unionId')
    http.post('_alive/open/xe.alive.wechatapplet.shop_ko_token_others', {
      app_id: appId,
      union_id: unionId
    }, false).then(res => {
      if (res.data.code === 0) {
        wx.hideLoading()
        wx.setStorageSync('koToken', res.data.data.ko_token)
        this.requestList.forEach(rq => rq())
        this.requestList = []
        this.isStoreLoggingIn = false
      } else {
        wx.hideLoading()
        wx.showToast({
          title: '接口异常-获取kotoken失败',
          icon: 'none'
        })
      }
    }).catch(() => {
      wx.hideLoading()
      wx.showToast({
        title: '接口异常-获取kotoken失败',
        icon: 'none'
      })
    })
  }

  /**
   * 小程序登录
   */
  wxLogin() {
    const that = this
    const unionId = wx.getStorageSync('unionId')
    if (unionId) {
      this.getKotoken()
    } else {
      wx.login({
        success(res) {
          if (res.code) {
            http.post('_alive/open/xe.alive.wechatapplet.login', {
              js_code: res.code,
            }, false).then(res => {
              if (res.data.code === 0) {
                wx.setStorageSync('unionId', res.data.data.union_id)
                that.getKotoken()
              }
            }).catch(() => {})
          }
        }
      })
    }
  }

  /**
   * 自定义域名地址
   * @param {自定义域名} host
   * @returns 作处理后的域名
   */
  getCustomBaseUrl(host) {
    if (host.includes('inside') || host.includes('test')) {
      return `https://${host}/`
    }
    let requestUrl = ''
    const baseUrl = host.split('.')
    const domainIndex = baseUrl.indexOf('com') - 1
    baseUrl.forEach((item, index) => {
      if (index === domainIndex) {
        requestUrl = `${requestUrl}${ENV_NAME ? `.${ENV_NAME}` : ''}.${baseUrl[domainIndex]}`
      } else {
        requestUrl = `${requestUrl}.${item}`
      }
    })
    requestUrl = `https://${requestUrl.substring(1)}/`
    return requestUrl
  }
}

export default new PlayerHttp()
